import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dashboard",
  "use": "icon-dashboard-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dashboard\">\n<path d=\"M21.9999 2H8V7H13V22H21.9999V2Z\" />\n<path d=\"M2 9H11V21.9976H2V9ZM5 17V19H8V17H5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol